// extracted by mini-css-extract-plugin
module.exports = {"switcherButton":"SwitcherButton_switcherButton__oixiY","active":"SwitcherButton_active__hyCbB","tooltip":"SwitcherButton_tooltip__wwEAr"};